import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ICourses } from '@core/interfaces/ilookup';
import { LookupService } from '@core/services/lookup.service';
import { take, tap } from 'rxjs';
import { ISelect } from '../interfaces/iselect';

@Component({
  selector: 'prism-select-course',
  templateUrl: './select-course.component.html',
  styleUrl: './select-course.component.scss',
})
export class SelectCourseComponent {
  @Output() course = new EventEmitter<any>();
  @Input() selected: ISelect = {
    selected: null,
    control: new FormControl(),
    label: 'Course',
    required: true,
    readOnly: false,
    labelClass: 'course-label',
  }
  options: ICourses[] = [];

  constructor(private lookupService: LookupService) {}

  ngOnInit(): void {
    this.getCourses();
  }

  getCourses(): void {
    this.lookupService
      .getCourses()
      .pipe(
        take(1),
        tap((res: ICourses[]) => (this.options = res))
      )
      .subscribe();
  }

  emitCourse(course: any): void {
    this.course.emit(course);
  }
}
